
import { Component, Input, ViewChild } from '@angular/core';
import { NavController, IonInfiniteScroll, LoadingController } from '@ionic/angular';
import { NewsListModel, NewsProvider, PagerModel } from '../../../providers/news/news';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { StorageProvider } from '../../../providers/storage-service/storage-service';
import { NewsController } from '../../../providers/news/news-contoller';
import { ConfigProvider } from '../../../providers/config/config';
import { Router } from '@angular/router';
import { NavigationService } from 'src/providers/navigation/navigation.service';

/**
 * Generated class for the NotificationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-notification',
  templateUrl: 'notification.html',
  styleUrls:['./notification.scss']
})
export class NotificationPage {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @Input()
  news: NewsListModel[] = [];
  dhl: boolean = false;
  appName: string = "";

  savedSearch: PagerModel = {
    limit: '25',
    page: '1',
    start: '0'
  }
  previousUrl:string;
  state:any;
  constructor(
    public navCtrl: NavController,
    public router:Router,
    private newsService: NewsProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private storageService: StorageProvider,
    private conf: ConfigProvider,
    private navService:NavigationService
  ) {
    console.log('constructior NotificationPage')
    new Promise<any>(async (resolve, reject) => {
      const nav = this.router.getCurrentNavigation();
      this.state = nav?.extras?.state || {};
      this.appName = (await this.conf.config).appId;
      this.previousUrl = this.navService.getPreviousUrl();
      if (this.state['news'] != null) {
        this.news = this.state['news'];
        this.dhl = this.state['dhl'];
        if (this.dhl) this.storageService.saveData(this.news, this.appName + '-news-dhl').then(() => {
          let type = (this.dhl) ? "newsDHL" : "newsGeneral";
          NewsController.getInstance().unreadNewsNumber[type] = 0;
          console.log(' NewsController.getInstance().unreadNewsNumber[type]: ', NewsController.getInstance().unreadNewsNumber[type]);
        })
      }
      else
        this.loadNews();

    });
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter NotificationPage');
    this.dhl = this.state['dhl'];
    console.log('this.dhl: ', this.dhl);
  }

  loadNews() {
    this.newsService.getMyNews(this.savedSearch).then(results => {
      this.news = results;
      this.storageService.saveData(this.news, this.appName + '-news-general');
    })
  }

  loadNextPage(event: any) {
    this.newsService.getMyNews(this.savedSearch).then(data => {
      this.news = this.news.concat(data);
      event.target.complete();
    });
  }

  async openDetails(id: number) {
    var loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    const prevTab = this.previousUrl? this.previousUrl.split('/')[1]:'/tab2/'
    this.newsService.getNews(id).then(results => {
      this.navCtrl.navigateForward(`${prevTab}/notification/details`, {state:{news: results}}).then(() => loader.dismiss());
      // this.navCtrl.push(NotificationDetailsPage, { news: results }).then(() => loader.dismiss());
    })
  }

}
